import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

export function TermsOfService() {
  return (
    <div className="container mx-auto py-8 max-w-3xl">
      <Card>
        <CardHeader>
          <CardTitle className="text-center">Terms of Service</CardTitle>
          <CardDescription className="text-center">
            Last Updated: {new Date().toLocaleDateString()}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">1. Acceptance of Terms</h3>
            <p className="text-gray-700 leading-relaxed">
              By accessing or using Secrely, you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not use our service.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">2. Service Description</h3>
            <p className="text-gray-700 leading-relaxed">
              Secrely provides a virtual assistant service that schedules meetings through phone calls. The service integrates with Google Calendar to manage and schedule events on behalf of users.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">3. Account Registration</h3>
            <p className="text-gray-700 leading-relaxed">
              To use Secrely, you must create an account and connect your Google Calendar. You are responsible for maintaining the security of your account credentials and for all activities that occur under your account.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">4. User Responsibilities</h3>
            <p className="text-gray-700 leading-relaxed">You agree to:</p>
            <ul className="list-disc pl-6 space-y-1 text-gray-700">
              <li>Provide accurate information when using our service</li>
              <li>Not use the service for any illegal or unauthorized purpose</li>
              <li>Not attempt to access data not intended for you</li>
              <li>Not interfere with the operation of the service</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">5. Google Calendar Integration</h3>
            <p className="text-gray-700 leading-relaxed">
              Our service requires access to your Google Calendar. By using Secrely, you authorize us to access, store, and modify calendar events on your behalf. You can revoke this access at any time through your Google account settings.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">6. Data Collection and Privacy</h3>
            <p className="text-gray-700 leading-relaxed">
              Your use of the service is also governed by our <a href="/privacy" className="text-blue-600 hover:underline">Privacy Policy</a>, which is incorporated by reference into these Terms of Service.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">7. Service Limitations and Modifications</h3>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify, suspend, or discontinue any part of the service at any time. We may also impose limits on certain features or restrict access to parts of the service without notice or liability.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">8. Intellectual Property</h3>
            <p className="text-gray-700 leading-relaxed">
              All content, features, and functionality of the Secrely service are owned by us or our licensors and are protected by copyright, trademark, and other intellectual property laws.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">9. Disclaimer of Warranties</h3>
            <p className="text-gray-700 leading-relaxed uppercase font-medium">
              THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT GUARANTEE THAT THE SERVICE WILL BE ERROR-FREE OR UNINTERRUPTED.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">10. Limitation of Liability</h3>
            <p className="text-gray-700 leading-relaxed uppercase font-medium">
              TO THE FULLEST EXTENT PERMITTED BY LAW, SECRELY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATING TO YOUR USE OF THE SERVICE.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">11. Governing Law</h3>
            <p className="text-gray-700 leading-relaxed">
              These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">12. Changes to Terms</h3>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to update or change these Terms at any time. We will provide notice of significant changes by posting the new Terms on this page.
            </p>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-xl font-semibold">13. Contact Information</h3>
            <p className="text-gray-700 leading-relaxed">
              For questions about these Terms, please contact us at: 
              <a href="mailto:anhminhnguyen1203@gmail.com" className="text-blue-600 hover:underline ml-1">anhminhnguyen1203@gmail.com</a>
            </p>
          </div>
          
          <div className="pt-6 text-center">
            <Button variant="outline" onClick={() => window.history.back()}>
              Return to App
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default TermsOfService; 